import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createRegistryOfSuspensionReasons, editRegistryOfSuspensionReasonsById, loadReasonList } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getFirstFormError, getResponseError, setFormError } from '../../../utils/utils';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import {
  PROCEDURE_TYPE,
  PROCEDURE_TYPE_LIST,
  REASON_TYPE_LIST,
  REFERENCE_ARGUMENT_TYPE,
  USER_TYPE_SHORT_NAME_LIST,
} from '../../../configs';
import RegistryOfSuspensionReasonsDTO from '../../../dto/RegistryOfSuspensionReasonsDTO';

import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import TextAreaWithLabel from '../../../components/fields/TextInput/TextAreaWithLabel';
import Switches from '../../../components/fields/Switches/Switches';

export default function RegistryOfSuspensionReasonsPageForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
    isEdit = false,
  } = props;
  const dispatch = useDispatch();
  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? current : null,
  });

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение основания', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    const action = isEdit ? editRegistryOfSuspensionReasonsById : createRegistryOfSuspensionReasons;
    dispatch(action({ ...values, id: current.id }))
      .then(() => {
        loadData();
        close();
        successNotification('Сохранение основания', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение основания', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new RegistryOfSuspensionReasonsDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle header={isEdit ? 'Редактирование основания' : 'Создание основания'} title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={Switches}
            dtoObject={attributes.block_180_days}
            variant="material"
            namePrefix="options."
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            multiple
            component={MultipleSelectInput}
            dtoObject={attributes.procedures}
            withLabel
            variant="material"
            options={PROCEDURE_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.law_number}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            multiple
            component={MultipleSelectInput}
            dtoObject={attributes.reasons_types}
            withLabel
            variant="material"
            options={REASON_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextAreaWithLabel}
            dtoObject={attributes.message}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.additional_message}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.legal_entity_types}
            variant="material"
            multiple
            withLabel
            options={USER_TYPE_SHORT_NAME_LIST}
          />
        </Row>
        <div className="mb-3" />
        <div className="f4">Автоматические решения</div>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            addPlaceholder
            component={CustomSelectInput}
            dtoObject={attributes.argument_type}
            withLabel
            placeholder="Тип аргумента"
            variant="material"
            options={REFERENCE_ARGUMENT_TYPE}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.argument_value}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextAreaWithLabel}
            dtoObject={attributes.ekdl_message}
            variant="material"
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
